export default __webpack_public_path__ + "static/media/samba_pickle.5dadd83c.gif";